import { MoovInstanceAbstractDTO } from "../DTO/moovInstanceAbstractDTO";

export class MoovInstanceAbstract{
    public id!: number;
    public customerId!: number;
    public sourceFileName!: string;
    public moovDefinitionName!: string;
    public added!: Date;

    

    public static mapFromDTO(param:MoovInstanceAbstractDTO):MoovInstanceAbstract{ 
        if (!param) throw new Error("parameter is null")
        let obj = new MoovInstanceAbstract();
        try
        {
            obj.id = param.id;
            obj.customerId = param.customerId;
            obj.sourceFileName = param.sourceFileName;
            obj.moovDefinitionName = param.moovDefinitionName;
            obj.added = new Date(param.added);
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:MoovInstanceAbstract):MoovInstanceAbstractDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new MoovInstanceAbstractDTO();
        try
        {
            dto.id = param.id;
            dto.customerId = param.customerId;
            dto.sourceFileName = param.sourceFileName;
            dto.moovDefinitionName = param.moovDefinitionName;
            dto.added = param.added.toISOString();
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }
}
